<template>
	<div class="Store-Type">
		<app-sales-performance />
		<StoreTypeTab @handler="setValueHandler"/>
		<div class="card">
			<div>
				<ReportTable :table-data="getAnalyticsData" @changePageNo="changePageNo">
					<template slot="button" slot-scope="{ element, indexOfRow }">
						<span
							v-if="disabled || element.label == 'Consolidated'"
							:class="[
								element.label == 'Consolidated' ? 'bold-link' : 'active-link'
							]"
							:style="[
								disabled && currentSelectedRow == indexOfRow
									? { color: '#38c172' }
									: null
							]"
						>
							{{ element.label ? element.label : "-" }}
						</span>
						<span
							v-else-if="element.basics == 'outlet'"
							:class="[
								element.basics == 'outlet' ? 'store-active-link' : 'active-link'
							]"
							:style="[
								disabled && currentSelectedRow == indexOfRow
									? { color: '#38c172' }
									: null
							]"
						>
							{{ element.label }}
						</span>
						<span
							v-else
							:class="[disabled ? 'bold-link' : 'active-link']"
							@click="rowButtonClicked(element, indexOfRow)"
						>
							{{ element.label ? element.label : "-" }}
						</span>
					</template>
				</ReportTable>
			</div>
			<div
				v-if="getAnalyticsData.length < 1"
				style="text-align: center; min-height: 260px; padding-top: 50px;"
			>
				<img
					src="../../../../assets/images/loader.svg"
					style="width: 80px; height: 80px;"
				/>
			</div>
			<div v-else>
				<baseReportGraph />
			</div>
		</div>
	</div>
</template>
<script>
import baseReportGraph from "../../../../components/baseReportGraph/baseReportGraph";
import ReportTable from "../reportTable/ReportTable.vue";
import StoreTypeTab from "../storeTypeTab/StoreTypeTab.vue";
import { mapGetters } from "vuex";
import { AppSalesTabNC } from "../../../../../mixins/appSalesTabNC";
import { EventBus } from "../../../../eventBus";

import AppSalesPerformance from "../reportPerformanceCard/ReportPerformanceCard";
export default {
	name: "StoreType",
	components: {
		StoreTypeTab,
		baseReportGraph,
		ReportTable,
		AppSalesPerformance
	},
	mixins: [AppSalesTabNC],
	data() {
		return {
			disabled: false,
			currentSelectedRow: null
		};
	},
	computed: {
		...mapGetters(["getAnalyticsData"])
	},
	mounted() {
		EventBus.$on("disableFirstButton", payload => {
			this.disabled = payload;
		});
	},
	beforeDestroy() {
		EventBus.$off("disableFirstButton");
	},
	methods: {
		setValueHandler(fn) {
			this.setter = fn
		},
		changePageNo(data) {
			console.log(data);
			this.setter(data);
			// this.$emit("pageInfoChangeReport", data);
			// this.changePage(data);
		},
		rowButtonClicked(element, indexOfRow) {
			this.currentSelectedRow = indexOfRow;
			this.disabled = true;
			console.log("element in sales location", element, indexOfRow);
			if (element.isShowGraph) {
				this.showGraphForPartRow(indexOfRow);
			}
			EventBus.$emit("buttonClickedEvent", element);
		},
		showGraphForPartRow(index) {
			const row = this.getAnalyticsData.data.rows[index];
			this.$store.commit("setNameOfGraph", row[0].value);
			const headings = this.getAnalyticsData.data.headings;
			this.plotOnlyDateGroupGraph(headings, row);
		}
	}
};
</script>
<style lang="scss" scoped>
@import "./StoreType.scss";
.AppWoowGraph {
	margin: 0;
}
</style>
